import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from './ProductSku.scss';

type ProductSkuProps = {
  className?: string;
  color?: string;
  colorClassName?: string;
  size?: string;
  sizeClassName?: string;
};

const ProductSku = ({
  className,
  color,
  colorClassName,
  size,
  sizeClassName,
}: ProductSkuProps) => {
  const isValidColor = !!color;
  const isValidSize = !!size;
  const shouldDisplay = isValidColor || isValidSize;

  if (shouldDisplay) {
    return (
      <div className={cn(className, colorClassName)}>
        {isValidColor && (
          <p className={s.productSku}>
            <span className={s.descriptionKey}>Color:</span>
            <span className={s.descriptionValue}>{color}</span>
          </p>
        )}
        {isValidSize && (
          <p className={cn(s.productSku, sizeClassName)}>
            <span className={s.descriptionKey}>Size:</span>
            <span className={s.descriptionValue}>{size}</span>
          </p>
        )}
      </div>
    );
  }
  return null;
};

export default ProductSku;
